import { create } from 'zustand'

import type { CsatActivePrompt } from '@/types/csat'

interface CsatStoreState {
  // Prompt atualmente exibido ao participante (ou null).
  activePrompt: CsatActivePrompt | null
  // Chaves de prompts já resolvidos/descartados nesta sessão, para não reabrir.
  dismissedKeys: string[]

  setActivePrompt: (prompt: CsatActivePrompt | null) => void
  // Marca a chave como resolvida na sessão e limpa o prompt ativo.
  dismiss: (key: string) => void
  isDismissed: (key: string) => boolean
}

export const useCsatStore = create<CsatStoreState>((set, get) => ({
  activePrompt: null,
  dismissedKeys: [],

  setActivePrompt: prompt => set({ activePrompt: prompt }),

  dismiss: key =>
    set(state => ({
      activePrompt: null,
      dismissedKeys: state.dismissedKeys.includes(key)
        ? state.dismissedKeys
        : [...state.dismissedKeys, key]
    })),

  isDismissed: key => get().dismissedKeys.includes(key)
}))

// Identificadores estáveis de prompt usados para evitar reapresentação na sessão.
export const promptKey = {
  interaction: (campaignId: number, type: string, id: number) =>
    `i:${campaignId}:${type}:${id}`,
  topic: (topicId: number) => `t:${topicId}`,
  final: (campaignId: number, answeredOn: string) =>
    `f:${campaignId}:${answeredOn}`
}
